import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { DOCS_ROOT } from './doc-kit'
import { DocsIndex } from './docs-index'
import { ENTRA_SSO_PATH, EntraSsoDoc } from './doc-entra-sso'
import { SCIM_PATH, ScimProvisioningDoc } from './doc-scim-provisioning'

// /public/docs: public integration guides, readable signed in or not.
// Not linked from the site's navigation yet (dev first; owner 2026-10-26).
export const DocsLayout = () => (
  <Switch>
    <Route exact path={DOCS_ROOT} component={DocsIndex} />
    <Route exact path={ENTRA_SSO_PATH} component={EntraSsoDoc} />
    <Route exact path={SCIM_PATH} component={ScimProvisioningDoc} />
    <Redirect to={DOCS_ROOT} />
  </Switch>
)
